module.exports = __webpack_public_path__ + "img/15@0.5x.png";